
document.addEventListener("DOMContentLoaded", function () {
    let isChecked = localStorage.getItem("giftCardChecked") === "true";
    let giftMessage = localStorage.getItem("giftMessage") || "";
    function updateGiftCardUI() {
        const uncheckedElements = document.querySelectorAll('#hon-svg__checkbox, #hon-svg__checkbox-cart-item');
        const checkedElements = document.querySelectorAll('#hon-checked-checkbox, #hon-checked-checkbox-cart-item');
        const fontSelections = document.querySelectorAll('.hon-font-selection__container .hon-cart-drawer__font-selection-option-list, .hon-font-selection__containers .hon-cart-drawer__font-selection-option-lists');
        const textareas = document.querySelectorAll('textarea.hon-cart-drawer__text-area-resize, textarea.hon-cart-drawer__text-area-resizes');
        uncheckedElements.forEach(element => {
            if (element) {
                element.style.display = isChecked ? "none" : "block";
            }
        });
        checkedElements.forEach(element => {
            if (element) {
                element.style.display = isChecked ? "block" : "none";
            }
        });
        fontSelections.forEach(fontSelection => {
            if (fontSelection) {
                fontSelection.style.display = isChecked ? "block" : "none";
            }
        });
        textareas.forEach(textarea => {
            if (textarea) {
                textarea.style.display = isChecked ? "block" : "none";
                textarea.value = isChecked ? giftMessage : "";
            }
        });
        attachClickListeners();
    }
    function toggleCheckbox() {
        isChecked = !isChecked;
        localStorage.setItem("giftCardChecked", isChecked.toString());
        updateGiftCardUI();
    }
    function handleTextInput(value) {
        giftMessage = value;
        localStorage.setItem("giftMessage", value);
        const textareas = document.querySelectorAll('textarea.hon-cart-drawer__text-area-resize, textarea.hon-cart-drawer__text-area-resizes');
        textareas.forEach(textarea => {
            if (textarea && textarea.value !== value) {
                textarea.value = value;
            }
        });
    }
    function attachClickListeners() {
        const allClickableElements = document.querySelectorAll('#hon-svg__checkbox, #hon-checked-checkbox, #hon-svg__checkbox-cart-item, #hon-checked-checkbox-cart-item');
        allClickableElements.forEach(element => {
            if (element && !element.hasAttribute('data-gift-card-listener')) {
                element.setAttribute('data-gift-card-listener', 'true');
                element.style.cursor = 'pointer'; 
                element.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    toggleCheckbox();
                });
            }
        });
        const textareas = document.querySelectorAll('textarea.hon-cart-drawer__text-area-resize, textarea.hon-cart-drawer__text-area-resizes');
        textareas.forEach(textarea => {
            if (textarea && !textarea.hasAttribute('data-gift-card-listener')) {
                textarea.setAttribute('data-gift-card-listener', 'true');
                textarea.addEventListener('input', function (event) {
                    handleTextInput(event.target.value);
                });
            }
        });
    }
    function reinitializeGiftCard() {
        document.querySelectorAll('[data-gift-card-listener]').forEach(element => {
            element.removeAttribute('data-gift-card-listener');
        });
        setTimeout(() => {
            updateGiftCardUI();
        }, 100);
    }
    const observer = new MutationObserver(function (mutations) {
        let shouldReinit = false;
        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) { 
                        if (node.querySelector && (
                            node.querySelector('[id*="hon-svg__checkbox"]') ||
                            node.querySelector('[id*="hon-checked-checkbox"]') ||
                            node.querySelector('textarea[class*="hon-cart-drawer__text-area"]')
                        )) {
                            shouldReinit = true;
                        }
                    }
                });
            }
        });

        if (shouldReinit) {
            reinitializeGiftCard();
        }
    });
    // Function to toggle checkbox state
    function toggleCheckbox() {
        isChecked = !isChecked;
        localStorage.setItem("giftCardChecked", isChecked.toString());
        if (!isChecked) {
            giftMessage = "";
            localStorage.removeItem("giftMessage");

            const textareas = document.querySelectorAll('textarea.hon-cart-drawer__text-area-resize, textarea.hon-cart-drawer__text-area-resizes');
            textareas.forEach(textarea => {
                textarea.value = "";
            });
        }
        updateGiftCardUI();
    }
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    updateGiftCardUI();
    window.reinitializeGiftCard = reinitializeGiftCard;
    setInterval(function () {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.classList.contains('active')) {
            const elementsNeedingListeners = document.querySelectorAll('#hon-svg__checkbox:not([data-gift-card-listener]), #hon-checked-checkbox:not([data-gift-card-listener]), #hon-svg__checkbox-cart-item:not([data-gift-card-listener]), #hon-checked-checkbox-cart-item:not([data-gift-card-listener])');
            if (elementsNeedingListeners.length > 0) {
                attachClickListeners();
            }
        }
    }, 1000);
});

// Function to handle the trimming logic
const handleLeadingSpace = (event) => {
  const target = event.target;
  // Check if it's our textarea
  if (target && target.id === 'CartDrawer-Note') {
    if (target.value.startsWith(' ')) {
      target.value = target.value.trimStart();
    }
  }
};

/**
 * We use 'true' as the third argument here. 
 * This triggers the "Capture" phase, ensuring our code runs 
 * before the cart's AJAX scripts can block the event.
 */
document.addEventListener('input', handleLeadingSpace, true);

// Also handle 'paste' events just in case
document.addEventListener('paste', (e) => {
  setTimeout(() => handleLeadingSpace(e), 0);
}, true);